import { render } from "./CustomerPage.vue?vue&type=template&id=3e40a962&scoped=true"
import script from "./CustomerPage.vue?vue&type=script&lang=js"
export * from "./CustomerPage.vue?vue&type=script&lang=js"

import "./CustomerPage.vue?vue&type=style&index=0&id=3e40a962&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e40a962"]])

export default __exports__